type IntentKey = string;

export const tasStateLabelMap: Record<IntentKey, string> = {
  // application states
  'TAS.ApplicationState.CREATED': 'Created',
  'TAS.ApplicationState.PENDING_EVIDENCE_APPROVAL': 'Pending Evidence Approval',
  'TAS.ApplicationState.FULFILLED': 'Complete',
  'TAS.ApplicationState.ATTEND': 'Attending',
  'TAS.ApplicationState.COURSES_NOT_APPROVED': 'Not Approved',
  CHANGES_REQUESTED: 'Change Requested',
  IN_PROGRESS: 'In Progress',
  CREATED: 'Created',
  DRAFT: 'Draft',
  'TAS.ApplicationState.DEFINE_COURSES': 'In Draft',
  'TAS.ApplicationState.PENDING_COURSES_APPROVAL': 'Pending Pre-Approval',
  'TAS.ApplicationState.COURSES_APPROVED': 'Approved',
  'TAS.ApplicationState.COURSES_REJECTED': 'Application Rejected',
  'TAS.ApplicationState.EVIDENCE_APPROVED': 'Evidence Approved',
  'TAS.ApplicationState.EVIDENCE_NOT_APPROVED': 'Evidence Not Approved',
  'TAS.ApplicationState.EVIDENCE_REJECTED': 'Evidence Rejected',
  'TAS.ApplicationState.REJECTED_PER_POLICY': 'Rejected Per Policy',
  'TAS.ApplicationState.ABANDONED': 'Abandoned',
  // payment states
  'TAS.ApplicationPaymentState.NONE': 'No Payment',
  'TAS.ApplicationPaymentState.UNPAID': 'Unpaid',
  'TAS.ApplicationPaymentState.PAID_IN_PART': 'Partially Paid',
  'TAS.ApplicationPaymentState.PAID_IN_FULL': 'Paid',
  'TAS.ApplicationPaymentState.REFUND_REQUESTED': 'In Repayment',
};

/**
 * Translation keys for the labels in `tasStateLabelMap`, keyed the same way. The en-us value of
 * each key equals the English label, so `intl.t(tasStateLabelKeyMap[state])` matches
 * `tasStateLabelMap[state]` in English.
 */
export const tasStateLabelKeyMap: Record<IntentKey, string> = {
  // application states
  'TAS.ApplicationState.CREATED': 'common.tas.state_badge.created',
  'TAS.ApplicationState.PENDING_EVIDENCE_APPROVAL':
    'common.tas.state_badge.pending_evidence_approval',
  'TAS.ApplicationState.FULFILLED': 'common.tas.state_badge.complete',
  'TAS.ApplicationState.ATTEND': 'common.tas.state_badge.attending',
  'TAS.ApplicationState.COURSES_NOT_APPROVED': 'common.tas.state_badge.not_approved',
  CHANGES_REQUESTED: 'common.tas.state_badge.change_requested',
  IN_PROGRESS: 'common.tas.state_badge.in_progress',
  CREATED: 'common.tas.state_badge.created',
  DRAFT: 'common.tas.state_badge.draft',
  'TAS.ApplicationState.DEFINE_COURSES': 'common.tas.state_badge.in_draft',
  'TAS.ApplicationState.PENDING_COURSES_APPROVAL': 'common.tas.state_badge.pending_pre_approval',
  'TAS.ApplicationState.COURSES_APPROVED': 'common.tas.state_badge.approved',
  'TAS.ApplicationState.COURSES_REJECTED': 'common.tas.state_badge.application_rejected',
  'TAS.ApplicationState.EVIDENCE_APPROVED': 'common.tas.state_badge.evidence_approved',
  'TAS.ApplicationState.EVIDENCE_NOT_APPROVED': 'common.tas.state_badge.evidence_not_approved',
  'TAS.ApplicationState.EVIDENCE_REJECTED': 'common.tas.state_badge.evidence_rejected',
  'TAS.ApplicationState.REJECTED_PER_POLICY': 'common.tas.state_badge.rejected_per_policy',
  'TAS.ApplicationState.ABANDONED': 'common.tas.state_badge.abandoned',
  // payment states
  'TAS.ApplicationPaymentState.NONE': 'common.tas.state_badge.no_payment',
  'TAS.ApplicationPaymentState.UNPAID': 'common.tas.state_badge.unpaid',
  'TAS.ApplicationPaymentState.PAID_IN_PART': 'common.tas.state_badge.partially_paid',
  'TAS.ApplicationPaymentState.PAID_IN_FULL': 'common.tas.state_badge.paid',
  'TAS.ApplicationPaymentState.REFUND_REQUESTED': 'common.tas.state_badge.in_repayment',
};
